export default __webpack_public_path__ + "static/828_3-d130513864b1281c27b7041f1f28af45.png";